export const FETCH_INVOICE = 'FETCH_INVOICE';
export const FETCH_USER_INVOICES = 'FETCH_USER_INVOICES';
